<template>
    <svg aria-hidden="true" focusable="false" width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 11L23 11" stroke="black" stroke-width="1.5" />
        <path d="M13.5 1L23 11L13.5 21" stroke="black" stroke-width="1.5" />
    </svg>
</template>
